<script setup lang="ts">
import { LogIn } from 'lucide-vue-next'
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer'
import UserAvatar from '@/components/UserMenu/UserAvatar.vue'
import UserMenuContent from '@/components/UserMenu/UserMenuContent.vue'

defineOptions({
  name: 'UserMenuDrawer',
})

const user = useUser()
const isOpen = ref(false)

function closeDrawer() {
  isOpen.value = false
}
</script>

<template>
  <div class="user-menu-wrapper">
    <!-- Trigger Button -->
    <button
      v-if="user"
      type="button"
      class="user-trigger"
      aria-label="User Menu"
      @click="isOpen = true"
    >
      <UserAvatar size="sm" />
    </button>

    <!-- Login Button if not authenticated -->
    <NuxtLink
      v-else
      to="/login?platform_redirect=/"
      class="user-trigger"
      aria-label="Sign In"
    >
      <LogIn :size="20" class="text-gray-600" />
    </NuxtLink>

    <!-- Drawer -->
    <Drawer v-model:open="isOpen">
      <DrawerContent>
        <DrawerHeader class="text-left pb-2">
          <div class="flex items-center gap-3">
            <UserAvatar size="lg" />
            <div class="flex-1 min-w-0">
              <DrawerTitle class="truncate">
                {{ user?.name || 'User' }}
              </DrawerTitle>
              <p class="text-sm text-muted-foreground truncate">
                {{ user?.username }}
              </p>
            </div>
          </div>
        </DrawerHeader>

        <div class="px-4 pb-8">
          <UserMenuContent @close="closeDrawer" />
        </div>
      </DrawerContent>
    </Drawer>
  </div>
</template>

<style lang="scss" scoped>
.user-menu-wrapper {
  @apply shrink-0;
}

.user-trigger {
  @apply
    flex
    items-center
    justify-center
    h-10
    w-10
    p-0
    rounded-md
    hover:bg-gray-100
    transition-colors
    duration-200;
}
</style>
